export default "__VITE_ASSET__utrqTncA__"